module.exports = __webpack_public_path__ + "media/images/icons/flags/AG-6e5b52d6f1d49587196b76ff3ae6fd7d.svg";